const video = {
	el: {
		videoContainer: document.querySelectorAll('.js-video')
	},

	fxTabSwitch(videoPlayer) {
		let inTab = true
		document.addEventListener('visibilitychange', () => {
			inTab = !inTab
			inTab && videoPlayer.parentElement.querySelector('.js-video-play').classList.contains('is-playing') ? videoPlayer.play() : videoPlayer.pause()
		})
	},

	fxTimeUpdateVideos(videoPlayer) {
		if (videoPlayer.parentElement.querySelector('.js-video-play').classList.contains('is-playing')) {
			videoPlayer.addEventListener('timeupdate', e => {
				if (e.currentTarget.currentTime || e.currentTarget.duration) {
					const percentage = Math.round((e.currentTarget.currentTime / e.currentTarget.duration) * 100)
					e.currentTarget.parentElement.querySelector('.js-video-seekbar').value = percentage
				}
			})
		}
	},

	fxActionsOnEndVideo(videoPlayer) {
		videoPlayer.addEventListener('ended', () => {
			videoPlayer.parentElement.querySelector('.js-video-play').classList.remove('is-playing')
			videoPlayer.currentTime = 0
			videoPlayer.load()
		})
	},

	fxTogglePlayVideo(videoPlayer, playButton) {
		playButton.addEventListener('click', e => {
			e.currentTarget.classList.toggle('is-playing')
			videoPlayer.paused ? videoPlayer.play() : videoPlayer.pause()
			this.fxTimeUpdateVideos(videoPlayer)
		})
	},

	fxToggleSoundVideo(videoPlayer, soundButton) {
		soundButton.addEventListener('click', e => {
			e.currentTarget.classList.toggle('has-sound')
			videoPlayer.muted = !videoPlayer.muted
		})
	},

	fxSeekVideo(videoPlayer, seekBar) {
		seekBar.addEventListener('click', e => {
			const percentage = (e.pageX - e.currentTarget.getBoundingClientRect().left) / e.currentTarget.clientWidth,
				time = videoPlayer.duration * percentage
			videoPlayer.currentTime = time
		})
	},

	fxPlaysInlineVideo(videoPlayer, playButtonInSlider, playButton) {
		playButtonInSlider && playButtonInSlider.forEach(el => {
			el.addEventListener('click', e => {
				const target = e.currentTarget,
					swiper = target.closest('.swiper-container').swiper

				swiper && swiper.autoplay.stop()

				const quoteParent = swiper && swiper.el.closest('.slider-quote')

				if (quoteParent) {
					const siblingSwiper = quoteParent.querySelector('.slider-quote__wrap .swiper-container')

					if (siblingSwiper && siblingSwiper.swiper) {
						siblingSwiper.swiper.autoplay.stop()
					}
				}

				target.closest('.swiper-slide').classList.add('video-is-playing')
				playButton.classList.add('is-playing')
				videoPlayer.paused ? videoPlayer.play() : videoPlayer.pause()
				this.fxTimeUpdateVideos(target.closest('.video-is-playing').querySelector('video'))
				target.closest('.slider-hero') && target.closest('.slider-hero').classList.add('hidden-progress-bar')
			})
		})
	},

	fxAutoPlayVideo(videoPlayer, autoPlayElement, playButton) {

		videoPlayer.addEventListener('playing', e => {
			if (autoPlayElement) {
				playButton.classList.add('is-playing')
				e.currentTarget.closest('.swiper-slide').classList.add('video-is-playing')
				autoPlayElement.closest('.slider-hero').classList.add('hidden-progress-bar')
				this.fxTimeUpdateVideos(videoPlayer)
			}
		})
	},

	events() {
		if (!this.el.videoContainer) return

		this.el.videoContainer.forEach(el => {
			const playButton = el.querySelector('.js-video-play'),
				soundButton = el.querySelector('.js-video-sound'),
				seekBar = el.querySelector('.js-video-seekbar'),
				videoPlayer = el.querySelector('video'),
				playButtonInSlider = el.closest('.js-slider') && el.closest('.js-slider').querySelectorAll('.js-slider-video-play'),
				autoPlayElement = el.classList.contains('js-autoplay') && el.parentElement.querySelector('.js-autoplay')

			this.fxTabSwitch(videoPlayer)
			this.fxActionsOnEndVideo(videoPlayer)
			this.fxTogglePlayVideo(videoPlayer, playButton)
			this.fxToggleSoundVideo(videoPlayer, soundButton)
			this.fxSeekVideo(videoPlayer, seekBar)
			this.fxPlaysInlineVideo(videoPlayer, playButtonInSlider, playButton)
			this.fxAutoPlayVideo(videoPlayer, autoPlayElement, playButton)
		})
	},

	init() {
		this.events()
	}
}

video.init()
